var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.title))])])]),_c('div',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }